/* ============================================================================
   ATHLO+ — Shoe Lab comparison tool
   ----------------------------------------------------------------------------
   Searchable picker → compare 2–4 running shoes side by side. Highlights the
   lightest + best-value pick, shareable via URL hash. Data: window.HUB_SHOES
   (assets/hub-shoes.js). Mounts into every [data-shoelab] root.
   ========================================================================== */
(function () {
  'use strict';

  // Category filter order — only those actually present in the data are shown.
  var CAT_ORDER = ['Race', 'Super trainer', 'Daily trainer', 'Max cushion', 'Stability', 'Trail', 'Flats', 'Recovery', 'Spikes', 'Field event', 'Football boots', 'Basketball', 'Tennis', 'Gym / training'];

  // Data is (re)built from the JS seed + window.HUB_SHOES_MO. The Liquid section
  // emits at most the first 250 metaobjects; hub-shoes-sf.js (when a Storefront
  // token is set) later replaces HUB_SHOES_MO with the FULL set and fires
  // 'hub:shoes-mo-full' → rebuild() re-mounts with every editable shoe.
  // (Merge admin metaobjects over the seed by id, so edits/photos win while the
  // full 514-shoe breadth is kept.)
  var SHOES = [], BY_ID = {}, CATS = [];
  function buildData() {
    var seed = (window.HUB_SHOES || []).slice();
    if (window.HUB_SHOES_MO && window.HUB_SHOES_MO.length) {
      var byId = {}; seed.forEach(function (s) { byId[s.id] = s; });
      window.HUB_SHOES_MO.forEach(function (s) { byId[s.id] = Object.assign({}, byId[s.id] || {}, s); });
      SHOES = Object.keys(byId).map(function (k) { return byId[k]; });
    } else {
      SHOES = seed;
    }
    SHOES.sort(function (a, b) { return (a.brand + a.model).localeCompare(b.brand + b.model); });
    BY_ID = {};
    SHOES.forEach(function (s) { BY_ID[s.id] = s; });
    CATS = CAT_ORDER.filter(function (c) { return SHOES.some(function (s) { return s.cat === c; }); });
  }
  buildData();
  if (!SHOES.length) return;

  // Spec rows rendered in the comparison grid. `best` flags numeric rows where
  // a lower value wins (we badge the winner). `fmt` formats the cell value.
  function rows(cur) {
    return [
      { key: 'cat',    label: 'Type' },
      { key: 'price',  label: 'Price',           best: 'low',  fmt: function (v) { return v ? cur + v : '—'; }, pill: 'Best value' },
      { key: 'weight', label: 'Weight',          best: 'low',  fmt: function (v) { return v ? v + 'g' : '—'; },  pill: 'Lightest' },
      { key: 'heel',   label: 'Heel stack',      fmt: function (v) { return v ? v + 'mm' : '—'; } },
      { key: 'fore',   label: 'Forefoot stack',  fmt: function (v) { return v ? v + 'mm' : '—'; } },
      { key: 'drop',   label: 'Drop',            fmt: function (v) { return (v || v === 0) && v !== '' ? v + 'mm' : '—'; } },
      { key: 'foam',   label: 'Midsole foam',    fmt: function (v) { return v && v !== '—' ? esc(v) : '—'; } },
      { key: 'plate',  label: 'Plate',           fmt: function (v) { return v ? esc(v) : '—'; } },
      { key: 'terrain',label: 'Surface',         fmt: function (v) { return v ? esc(v) : '—'; } },
      { key: 'year',   label: 'Released' },
      { key: 'use',    label: 'Best for' },
      /* WINS. Not "who endorses this" - that decays the moment a contract does,
         and is mostly inferred from race photos. A result on a date is permanent
         and citable, and "this is what actually wins" is the stronger signal. */
      { key: 'wins',   label: 'Won',
        fmt: function (v) {
          if (!v || !v.length) return '—';
          return v.map(function (w) {
            return '<span class="shoelab__win"><b>' + esc(w.year + ' ' + w.race) + '</b>' +
                   '<span>' + esc(w.who) + (w.note ? ' · ' + esc(w.note) : '') + '</span></span>';
          }).join('');
        } }
    ];
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function track(name, detail) {
    try { window.dispatchEvent(new CustomEvent('hub:shoelab', { detail: Object.assign({ event: name }, detail || {}) })); } catch (e) {}
    if (typeof window.gtag === 'function') window.gtag('event', name, detail || {});
    if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(Object.assign({ event: name }, detail || {}));
  }

  function Lab(root) {
    var MAX = Math.min(parseInt(root.getAttribute('data-max'), 10) || 4, 4);
    var CUR = root.getAttribute('data-currency') || '$';

    // Retail partner for the "where to buy" row. Entirely driven by the section
    // settings — with no data-partner-name the row never renders, so the whole
    // feature is off by default and removable without touching this file.
    var PARTNER = {
      name:    root.getAttribute('data-partner-name') || '',
      label:   root.getAttribute('data-partner-label') || 'Where to buy',
      product: root.getAttribute('data-partner-product') || '',
      search:  root.getAttribute('data-partner-search') || ''
    };
    var STOCK = window.HUB_PARTNER_STOCK || {};

    // Link priority: a per-shoe buy_url set in Admin beats the generated stock
    // map, which beats a search. Returns '' when nothing can be built.
    function partnerUrl(s) {
      if (s.buy) return s.buy;
      var handle = STOCK[s.id];
      if (handle && PARTNER.product) return PARTNER.product.replace('{handle}', encodeURIComponent(handle));
      if (PARTNER.search) return PARTNER.search.replace('{q}', encodeURIComponent(s.brand + ' ' + s.model));
      return '';
    }
    /* Curated match-ups. Lifted out of the empty state because the empty state is
       going away: the tool now opens on the first one, and these have to stay
       reachable so you can jump between them. */
    var MATCHUPS = [
      ['Vaporfly 4 vs 3',        ['nike-vaporfly-4', 'nike-vaporfly-3']],
      ['Carbon racer showdown',  ['nike-vaporfly-4', 'adidas-adios-pro-4', 'saucony-endorphin-pro-4', 'asics-metaspeed-sky-tokyo']],
      ['Super trainer face-off', ['asics-superblast-3', 'nike-pegasus-plus', 'adidas-evo-sl']],
      ['Max cushion',            ['hoka-bondi-9', 'nike-invincible-3', 'nb-more-v5']],
      ['Track spikes',           ['nike-maxfly-2', 'nike-dragonfly-2', 'adidas-avanti-tyo']]
    ];
    var selected = [];           // array of shoe ids
    var combo = { open: false, q: '', items: [], active: -1, cat: CATS[0] || '' };

    /* YOUR BUILD AS A COLUMN. The simulator lets you invent a shoe; this is what
       makes that worth doing - the invented one drops into the same table as the
       real ones and gets scored by the same rules, badges included.

       It is kept OUT of SHOES so it can never turn up in search results; it only
       ever exists in BY_ID and in `selected`. */
    var BUILD_ID = 'your-build';
    function buildShoe(d) {
      var heel = +d.heel, fore = +d.fore;
      return {
        id: BUILD_ID, brand: 'Your build', model: 'Custom', cat: 'Your build',
        heel: heel, fore: fore, drop: +(heel - fore).toFixed(1),
        weight: +d.weight || null,
        plate: d.plate && d.plate !== 'none' ? (d.plate.charAt(0).toUpperCase() + d.plate.slice(1)) : 'None',
        terrain: 'Road', use: 'The shoe you built on the bench', isBuild: true
      };
    }
    /* Encoded into the URL as your-build~heel-fore-weight-plate so a shared
       "my build vs the Vaporfly" link actually reopens the build. */
    function encodeBuild(s) {
      return BUILD_ID + '~' + [s.heel, s.fore, s.weight || 0, (s.plate || 'None').toLowerCase()].join('-');
    }
    function decodeBuild(tok) {
      var m = tok.match(/^your-build~([\d.]+)-([\d.]+)-(\d+)-(\w+)$/);
      if (!m) return null;
      return buildShoe({ heel: m[1], fore: m[2], weight: +m[3] || null, plate: m[4] });
    }

    /* ---------- URL state (shareable comparisons) ----------------------- */
    /* Accepts BOTH ?compare= and #compare=. The query form is what makes a
       match-up a link you can paste anywhere; Shopify canonicalises query
       strings back to /pages/shoe-lab, so these share safely without spawning
       duplicate URLs in the index. */
    function readState() {
      var m = (location.search || '').match(/[?&]compare=([^&]+)/) ||
              (location.hash   || '').match(/compare=([^&]+)/);
      if (m) {
        decodeURIComponent(m[1]).split(',').forEach(function (id) {
          if (id.indexOf(BUILD_ID + '~') === 0) {
            var b = decodeBuild(id);
            if (b && selected.indexOf(BUILD_ID) < 0 && selected.length < MAX) {
              BY_ID[BUILD_ID] = b; selected.push(BUILD_ID);
            }
            return;
          }
          if (BY_ID[id] && selected.indexOf(id) < 0 && selected.length < MAX) selected.push(id);
        });
      }
      /* NEVER OPEN EMPTY. The tool used to render a search box and nothing else -
         618 shoes in memory and zero on screen - which is what made the page feel
         like it had nothing in it. Seed the first match-up instead, and leave the
         URL alone so the canonical page keeps a clean address. */
      if (!selected.length && MATCHUPS.length) {
        selected = MATCHUPS[0][1].filter(function (id) { return BY_ID[id]; }).slice(0, MAX);
      }
    }
    function writeHash() {
      /* Query form, so the address bar holds something you can actually paste.
         Other params (?v=, utm_*) are preserved; the quiz fragment is too. */
      var params = [];
      (location.search || '').replace(/^\?/, '').split('&').forEach(function (kv) {
        if (kv && kv.indexOf('compare=') !== 0) params.push(kv);
      });
      var toks = selected.map(function (id) {
        return (id === BUILD_ID && BY_ID[BUILD_ID]) ? encodeBuild(BY_ID[BUILD_ID]) : id;
      });
      if (toks.length) params.push('compare=' + encodeURIComponent(toks.join(',')));
      var frag = location.hash.indexOf('quiz') > -1 ? location.hash : '';
      history.replaceState(null, '', location.pathname + (params.length ? '?' + params.join('&') : '') + frag);
    }

    /* ---------- mutations ----------------------------------------------- */
    function add(id) {
      if (!BY_ID[id] || selected.indexOf(id) > -1 || selected.length >= MAX) return;
      selected.push(id); writeHash(); render();
      track('shoelab_add', { shoe: id, count: selected.length });
    }
    function remove(id) {
      selected = selected.filter(function (x) { return x !== id; });
      writeHash(); render();
    }
    function clear() { selected = []; writeHash(); render(); }

    /* ---------- combobox ------------------------------------------------ */
    /* 269 of the 618 records are NAME ONLY -- a bulk import with no stack, no
       weight, no price (they all carry a filler year of 2021, which nothing
       displays). They are still worth finding, because knowing a shoe exists in
       the Lab is useful, but comparing one produces a column of em-dashes. So
       they sort BELOW anything with real specs and get labelled, instead of
       being silently mixed in and disappointing whoever picks one. */
    /* "Has this record got anything to compare?" — NOT "does it have a stack".
       A track spike legitimately has no stack (23 of ours are heel:0 by design),
       so the stack test demoted every well-specced spike to the bottom of search
       and labelled the Nike Maxfly 2 — 177g, $200, carbon plate — as "name only".
       Weight and price are the two fields that mean something on every kind of
       footwear here, so they are the test. Under this rule exactly 269 records
       are thin, which is the bulk-import stub count, so it lines up. */
    function specced(s) { return s.weight > 0 || s.price > 0; }

    function matches(q) {
      q = q.trim().toLowerCase();
      var pool = SHOES.filter(function (s) { return selected.indexOf(s.id) < 0; });
      // Typed search spans every category so nothing is hidden; the chips only
      // scope the browse view when the box is empty.
      if (q) {
        pool = pool.filter(function (s) {
          return (s.brand + ' ' + s.model + ' ' + s.cat + ' ' + (s.terrain || '')).toLowerCase().indexOf(q) > -1;
        });
      } else if (combo.cat) {
        pool = pool.filter(function (s) { return s.cat === combo.cat; });
      }
      return pool.slice().sort(function (a, b) {
        return (specced(b) ? 1 : 0) - (specced(a) ? 1 : 0);
      }).slice(0, 12);
    }

    function render() {
      root.innerHTML = '';
      var atMax = selected.length >= MAX;

      /* picker bar */
      var bar = el('div', 'shoelab__bar');
      if (!atMax) {
        var box = el('div', 'shoelab__combo');
        var input = el('input', 'shoelab__input');
        input.type = 'text';
        input.setAttribute('role', 'combobox');
        input.setAttribute('aria-expanded', 'false');
        input.setAttribute('aria-autocomplete', 'list');
        input.placeholder = selected.length ? 'Add another shoe…' : 'Search a shoe — e.g. Vaporfly, Hoka, daily trainer…';
        var list = el('div', 'shoelab__list');
        list.setAttribute('role', 'listbox');

        function renderList() {
          combo.items = matches(input.value);
          list.innerHTML = '';
          if (!combo.open || !combo.items.length) { box.classList.remove('is-open'); input.setAttribute('aria-expanded', 'false'); return; }
          combo.items.forEach(function (s, i) {
            var opt = el('button', 'shoelab__opt' + (i === combo.active ? ' is-active' : ''));
            opt.type = 'button';
            opt.setAttribute('role', 'option');
            // Half the catalogue has no weight/price (researched, not invented — left blank on
            // purpose), which used to render as a bare "· g · $". Skip empty specs, and escape
            // them: these values come from admin-editable metaobjects.
            var meta = [esc(s.cat)];
            if (s.weight) meta.push(esc(s.weight) + 'g');
            if (s.price) meta.push(CUR + esc(s.price));
            if (!specced(s)) meta.push('name only — no specs yet');
            opt.innerHTML = '<span class="shoelab__opt-name"><b>' + esc(s.brand) + '</b> ' + esc(s.model) + '</span>' +
                            '<span class="shoelab__opt-meta">' + meta.join(' · ') + '</span>';
            opt.addEventListener('mousedown', function (e) { e.preventDefault(); add(s.id); });
            list.appendChild(opt);
          });
          box.classList.add('is-open');
          input.setAttribute('aria-expanded', 'true');
        }
        input.addEventListener('focus', function () { combo.open = true; combo.active = -1; renderList(); });
        input.addEventListener('input', function () { combo.open = true; combo.active = -1; renderList(); });
        input.addEventListener('blur', function () { setTimeout(function () { combo.open = false; box.classList.remove('is-open'); }, 120); });
        input.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault(); combo.open = true;
            if (!combo.items.length) { renderList(); return; }
            combo.active += (e.key === 'ArrowDown' ? 1 : -1);
            if (combo.active < 0) combo.active = combo.items.length - 1;
            if (combo.active >= combo.items.length) combo.active = 0;
            renderList();
          } else if (e.key === 'Enter') {
            e.preventDefault();
            var pick = combo.items[combo.active < 0 ? 0 : combo.active];
            if (pick) { add(pick.id); input.value = ''; }
          } else if (e.key === 'Escape') { combo.open = false; box.classList.remove('is-open'); }
        });
        box.appendChild(input); box.appendChild(list);
        bar.appendChild(box);

        // category filter chips — pick a discipline to browse (no "All": mixing
        // e.g. spikes with max-cushion makes the comparison meaningless). Type in
        // the search box to look across every category at once.
        var cats = el('div', 'shoelab__cats');
        CATS.forEach(function (c) {
          var chip = el('button', 'shoelab__cat' + (combo.cat === c ? ' is-on' : ''), c);
          chip.type = 'button';
          chip.addEventListener('click', function () { combo.cat = (combo.cat === c ? '' : c); combo.open = true; render(); var ni = root.querySelector('.shoelab__input'); if (ni) { ni.focus(); } });
          cats.appendChild(chip);
        });
        bar.appendChild(cats);
      } else {
        bar.appendChild(el('p', 'shoelab__full', 'Comparing the max of ' + MAX + ' shoes. Remove one to swap it out.'));
      }

      if (selected.length) {
        var tools = el('div', 'shoelab__tools');
        var share = el('button', 'shoelab__tool', '🔗 Copy compare link');
        share.type = 'button';
        share.addEventListener('click', function () {
          writeHash();
          var url = location.href;
          var done = function () { share.textContent = '✓ Link copied'; setTimeout(function () { share.textContent = '🔗 Copy compare link'; }, 1800); };
          if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, done); else done();
          track('shoelab_share', { count: selected.length });
        });
        var reset = el('button', 'shoelab__tool', 'Clear all');
        reset.type = 'button';
        reset.addEventListener('click', clear);
        tools.appendChild(share); tools.appendChild(reset);
        bar.appendChild(tools);
      }
      root.appendChild(bar);

      /* Match-ups, always on. These used to live inside an empty state that the
         tool no longer has, and they are the fastest route into the data for
         someone who does not yet know what to search for. */
      /* Authority line. 285 shoes with a full spec across 34 brands is a bigger
         measured database than RTINGS has bought and tested, and the page never
         said so. Counted live, so it cannot drift from the data. */
      var full = SHOES.filter(function (x) { return x.heel > 0 && x.fore > 0 && x.weight > 0; });
      var brands = {};
      SHOES.forEach(function (x) { if (x.brand) brands[x.brand] = 1; });
      var stat = el('p', 'shoelab__stat');
      stat.innerHTML = '<strong>' + SHOES.length + '</strong> shoes · <strong>' +
        full.length + '</strong> with a full measured spec · <strong>' +
        Object.keys(brands).length + '</strong> brands';
      root.appendChild(stat);

      var chipsWrap = el('div', 'shoelab__matchups');
      var chipsLab = el('span', 'shoelab__matchups-l', 'Jump to a match-up:');
      chipsWrap.appendChild(chipsLab);
      var chips = el('div', 'shoelab__chips');
      MATCHUPS.forEach(function (preset) {
        var ids = preset[1].filter(function (id) { return BY_ID[id]; }).slice(0, MAX);
        if (!ids.length) return;
        var on = ids.length === selected.length &&
                 ids.every(function (id) { return selected.indexOf(id) > -1; });
        var chip = el('a', 'shoelab__chip' + (on ? ' is-on' : ''), preset[0]);
        /* A real href: middle-click and "copy link" work, and the URL it points at
           is the one the tool restores from. */
        chip.href = location.pathname + '?compare=' + encodeURIComponent(ids.join(','));
        if (on) chip.setAttribute('aria-current', 'true');
        chip.addEventListener('click', function (e) {
          e.preventDefault();
          selected = ids.slice();
          writeHash(); render();
          track('shoelab_preset', { preset: preset[0] });
        });
        chips.appendChild(chip);
      });
      chipsWrap.appendChild(chips);
      root.appendChild(chipsWrap);

      /* comparison grid */
      var shoes = selected.map(function (id) { return BY_ID[id]; });
      var SPEC = rows(CUR);

      // winners for low-is-best numeric rows (ignore 0 / blank — e.g. boots)
      var winners = {};
      SPEC.forEach(function (r) {
        if (r.best !== 'low') return;
        var vals = shoes.map(function (s) { return s[r.key]; }).filter(function (v) { return typeof v === 'number' && v > 0; });
        winners[r.key] = vals.length ? Math.min.apply(null, vals) : null;
      });

      // hide stack/drop rows for footwear that has no meaningful stack (spikes,
      // boots, court shoes) — i.e. every selected shoe has 0 heel AND 0 forefoot.
      var noStack = shoes.every(function (s) { return !s.heel && !s.fore; });
      function rowEmpty(r) {
        if (noStack && (r.key === 'heel' || r.key === 'fore' || r.key === 'drop')) return true;
        return shoes.every(function (s) { var v = s[r.key]; return v == null || v === '' || v === '—'; });
      }

      var scroller = el('div', 'shoelab__scroll');
      var grid = el('div', 'shoelab__grid');
      grid.style.setProperty('--cols', shoes.length);

      // header row: label cell + shoe cards
      var head = el('div', 'shoelab__row shoelab__row--head');
      head.appendChild(el('div', 'shoelab__cell shoelab__cell--label', '<span class="shoelab__count">' + shoes.length + ' / ' + MAX + '</span>'));
      shoes.forEach(function (s) {
        var c = el('div', 'shoelab__cell shoelab__cell--card');
        // optional photo/video per shoe (set s.img or s.video in hub-shoes.js)
        var media = '';
        if (s.video) media = '<span class="shoelab__media"><video src="' + esc(s.video) + '" muted loop playsinline autoplay preload="metadata"></video></span>';
        else if (s.img) media = '<span class="shoelab__media"><img src="' + esc(s.img) + '" alt="' + esc(s.brand + ' ' + s.model) + '" loading="lazy"></span>';
        c.innerHTML =
          '<button class="shoelab__remove" type="button" aria-label="Remove ' + esc(s.brand + ' ' + s.model) + '">&times;</button>' +
          media +
          '<span class="shoelab__brand">' + esc(s.brand) + '</span>' +
          '<span class="shoelab__name">' + esc(s.model) + '</span>';
        c.querySelector('.shoelab__remove').addEventListener('click', function () { remove(s.id); });
        head.appendChild(c);
      });
      grid.appendChild(head);

      // spec rows
      SPEC.forEach(function (r) {
        if (r.key !== 'cat' && rowEmpty(r)) return; // hide irrelevant rows (e.g. stack/drop for boots)
        var row = el('div', 'shoelab__row');
        row.appendChild(el('div', 'shoelab__cell shoelab__cell--label', r.label));
        shoes.forEach(function (s) {
          var raw = s[r.key];
          var val = r.fmt ? r.fmt(raw) : esc(raw);
          var isWin = r.best === 'low' && raw === winners[r.key];
          var c = el('div', 'shoelab__cell' + (isWin ? ' is-best' : '') + (r.key === 'use' ? ' shoelab__cell--use' : ''));
          c.innerHTML = '<span class="shoelab__val">' + val + '</span>' +
            (isWin && shoes.length > 1 ? '<span class="shoelab__pill">' + r.pill + '</span>' : '');
          row.appendChild(c);
        });
        grid.appendChild(row);
      });

      // "where to buy" row — the one place the Lab stops describing and starts
      // pointing somewhere. Kept out of SPEC because it renders a link, not a
      // value, and must never be hidden by rowEmpty().
      if (PARTNER.name) {
        var brow = el('div', 'shoelab__row shoelab__row--buy');
        brow.appendChild(el('div', 'shoelab__cell shoelab__cell--label', esc(PARTNER.label)));
        shoes.forEach(function (s) {
          var c = el('div', 'shoelab__cell shoelab__cell--buy');
          var href = partnerUrl(s);
          if (href) {
            // "stocked" means we matched it to a real product, not that it is in
            // stock right now — the map carries no live inventory, so the copy
            // says View vs Search rather than claiming availability.
            var stocked = !!(s.buy || STOCK[s.id]);
            var a = el('a', 'shoelab__buy' + (stocked ? ' is-stocked' : ''),
              (stocked ? 'View at ' : 'Search ') + esc(PARTNER.name) + ' <span aria-hidden="true">&rarr;</span>');
            a.href = href;
            a.target = '_blank';
            a.rel = 'noopener sponsored';
            a.setAttribute('aria-label', (stocked ? 'View ' : 'Search for ') + esc(s.brand + ' ' + s.model) + ' at ' + esc(PARTNER.name) + ' (opens in a new tab)');
            a.addEventListener('click', function () {
              track('shoelab_partner_click', { shoe: s.id, partner: PARTNER.name, stocked: stocked });
            });
            c.appendChild(a);
          } else {
            c.innerHTML = '<span class="shoelab__val">&mdash;</span>';
          }
          brow.appendChild(c);
        });
        grid.appendChild(brow);
      }

      scroller.appendChild(grid);
      root.appendChild(scroller);
    }

    /* The bench sends its current build over. Bring the closest real shoe with it
       when nothing else is picked - a lone "Your build" column compares against
       nothing and teaches nothing. */
    function acceptBuild(e) {
      var d = e && e.detail; if (!d || !d.heel) return;
      BY_ID[BUILD_ID] = buildShoe(d);
      selected = selected.filter(function (x) { return x !== BUILD_ID; });
      if (!selected.length && d.nearest && BY_ID[d.nearest]) selected.push(d.nearest);
      selected.unshift(BUILD_ID);
      selected = selected.slice(0, MAX);
      writeHash(); render();
      track('shoelab_build_compare', { heel: d.heel, fore: d.fore });
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    window.addEventListener('hub:build-compare', acceptBuild);

    readState();
    if (BY_ID[BUILD_ID] && selected.indexOf(BUILD_ID) > -1) {
      var b = BY_ID[BUILD_ID];
      var payload = { heel: b.heel, fore: b.fore, weight: b.weight, plate: (b.plate || 'none').toLowerCase() };
      /* BOTH a global and an event, deliberately. These two scripts are deferred
         and hub-shoe-lab.js runs FIRST, so an event alone fires before the bench
         has registered its listener and is lost. The global is what actually
         works on a cold load; the event covers anything dispatched later. */
      window.HUB_PENDING_BUILD = payload;
      try { window.dispatchEvent(new CustomEvent('hub:build-restore', { detail: payload })); } catch (e) {}
    }
    render();
  }

  function init() {
    document.querySelectorAll('[data-shoelab]').forEach(function (root) {
      if (root.__shoelab) return;
      root.__shoelab = true;
      new Lab(root);
    });
  }

  // Full-catalogue upgrade: hub-shoes-sf.js replaced HUB_SHOES_MO with all shoes
  // → rebuild the data and re-mount (selection lives in the URL hash, so it's
  // preserved by the fresh mount's readHash()).
  function rebuild() {
    buildData();
    document.querySelectorAll('[data-shoelab]').forEach(function (root) { root.__shoelab = false; });
    init();
  }
  window.addEventListener('hub:shoes-mo-full', rebuild);

  /* The nav cards are plain in-page anchors, so hub-app.js's global
     a[href^="#"] handler already does the scrolling -- correctly, through Lenis
     with the -70 sticky-header offset. Do NOT re-implement it here: an earlier
     version called scrollIntoView on top of that and the two fought, with Lenis
     overshooting the target by 1,300px.

     The one thing that handler cannot know about is a folded <details>. Opening
     it must happen BEFORE the scroll settles, or you land on a bare heading. */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('.shoelab__navcard');
    if (!a) return;
    var id = (a.getAttribute('href') || '').replace(/^#/, '');
    var t = id && document.getElementById(id);
    if (t && t.tagName === 'DETAILS') t.open = true;
  }, true);   // capture, so the fold is open before the scroll is measured

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
